import ApiGet from '../../../../api-module/api-configuration/get-api/getApi';
import { JobRole } from '../../../../component-module/component-services/list/job-role/ts/jobRole.type';
import { TalentStep } from '../../../../component-module/component-services/list/talents/ts/talent';
import { API_ENDPOINTS } from '../../../../context-module/context-configuration/auth-provider/apiGroup/apiProvider';

type RawStep = {
  id?: any;
  step?: string;
  title?: string;
  description?: string;
  button?: {
    title?: string;
  };
};

export type CareerPageData = {
  career: CareerContent;
};

export type CareerContent = {
  key: string;
  title: string;
  visible: boolean;
  cta: CareerCta[];
};

export type CareerCta = {
  heroSection?: CareerHeroSection;
  positionSection?: CareerPositionSection;
  submissionStepSection?: CareerSubmissionStepSection;
};

export type CareerHeroSection = {
  key: string;
  visible: boolean;
  headline: string;
  primaryButton?: {
    key: string;
    label: string;
    visible: boolean;
  };
};

export type CareerPositionSection = {
  key: string;
  visible: boolean;
  content: Array<{
    key: string;
    listSection?: {
      key: string;
      visible: boolean;
      list?: {
        visible: boolean;
        items: CareerJobItem[];
      };
    };
    headerSection?: {
      key: string;
      label?: string;
      title?: string;
      visible: boolean;
      actionButton?: {
        label?: string;
        visible: boolean;
      };
    };
  }>;
};

export type CareerJobItem = {
  id: string;
  code: string;
  title: string;
  location: string;
};

export type CareerSubmissionStepSection = {
  key: string;
  visible: boolean;
  content: Array<{
    key: string;
    headerSection?: {
      key: string;
      label?: string;
      title?: string;
      description?: string;
      visible: boolean;
      list?: {
        visible: boolean;
        items: CareerStepItem[];
      };
    };
  }>;
};

export type CareerStepItem = {
  id: string;
  step: string;
  title: string;
  description: string;
  button?: {
    title?: string;
  };
};



export const mapStepsWithApplyButton = (
  rawSteps: RawStep[],
  onApplyNow: () => void
): TalentStep[] => {
  return rawSteps.map((step, index) => {
    const hasButton = index === 0 && !!step?.button?.title;

    return {
      id: step.id ,
      step: step.step ?? "",
      title: step.title ?? "",
      description: step.description ?? "",

      hasButton,
      buttonText: hasButton ? step.button!.title : undefined,
      onButtonClick: hasButton ? onApplyNow : undefined,
    };
  });
};

export const createTalentSteps = (
  onApplyNow: () => void
): TalentStep[] => [
  {
    id: '1',
    step: 'STEP 1',
    title: 'Application Submission',
    description:
      'Candidate submits CV, portfolio, and required documents. Our team will review your CV and statement of exceptional work.',
    hasButton: true,
    buttonText: 'Apply now',
    onButtonClick: onApplyNow,
  },
  {
    id: '2',
    step: 'STEP 2',
    title: 'Initial Screening',
    description:
      'HR reviews qualifications, skills, and experience. Shortlisted candidates move to the next step.',
  },
  {
    id: '3',
    step: 'STEP 3',
    title: 'Technical / Skills Assessment',
    description:
      'Candidate completes a relevant test. Evaluated by the department lead.',
  },
  {
    id: '4',
    step: 'STEP 4',
    title: 'Management Interview',
    description:
      'Company values understanding, Discuss benefits, working style, salary negotiation',
  },
  {
    id: '5',
    step: 'STEP 5',
    title: 'Offer Letter',
    description:
      "If you've demonstrated the exceptional skills and mindset we're looking for, we'll extend an offer.",
  },
];

export type ApiListResponse<T> = {
  success: boolean;
  requestId: string;
  data: {
    items: T[];
    pagination: {
      page: number;
      size: number;
      totalRecords: number;
      totalPages: number;
      hasNext: boolean;
      hasPrevious: boolean;
    };
  };
};

export type JobIndexItem = {
  jobId: string;
  jobCode: string;
  jobTitle: string;
  slug: string;
  departmentName: string;
  jobLevelName: string;
  jobType: string;
  status: string;
  publishedAt: string | null;
  closedAt: string | null;
  createdAt: string; 
};

export const mapJobIndexToJobRoles = (items: JobIndexItem[]): JobRole[] =>
  items.map((x) => ({
    id: x.jobId,
    code: x.jobCode,
    title: x.jobTitle,
    location: x.departmentName, 
  }));

export const getJobIndexApi = (page = 1, size = 10) => {
  return ApiGet<ApiListResponse<JobIndexItem>>(
    `${API_ENDPOINTS.GET_JOB_INDEX}?page=${page}&size=${size}`
  );
};

export type CmsPageResponse<TPageData> = {
  success: boolean;
  requestId: string;
  data: {
    contentId: string;
    contentVersionUuid: string;
    slug: string;
    type: "page" | string; //NOSONAR
    title: string;
    status: "PUBLISHED" | "DRAFT" | string; //NOSONAR
    version: number;
    data: TPageData;
    createdAt: string;
  };
};

export type JobDetailPageData = {
  jobDetail: JobDetailContent;
};

export type JobDetailContent = {
  key: string;
  title: string;
  visible: boolean;
  cta: Array<{
    submitJobSection?: SubmitJobSection;
  }>;
};

export type SubmitJobSection = {
  key: string;
  type?: string;
  author?: string;
  status?: string;
  visible: boolean;
  content: Array<{
    headerSection: {
      key: string;
      visible: boolean;
      label: string;
      title: string;
      description: string;
      subDescription: string;
      button: {
        label: string;
      };
    };
  }>;
};
